import type { FaireProductEntity } from "../../entity_types/product";

export const p_2su4rcfyag: FaireProductEntity = {
  token: "p_2su4rcfyag",
  type: "product",
  name: "Sedona Arizona T-Shirt – Red Earth Reverie Western Desert Tee, Cowboy Boot Souvenir, Southwest Travel Gift Shirt",
  brandToken: "b_z962y8xcqr",
  brandName: "Textile Graphix",
  imageUrl:
    "https://cdn.faire.com/fastly/013f78cd13c152cf307f1c7fb766abfec590962bd188ffd1828f14253a777eed.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/47b8168dd0cb93fba79e39b29c295822e2d38d5a578ed361364458abde31c36c.jpeg",
    "https://cdn.faire.com/fastly/85a933ec410651e3bc1f49177c29bf463f033580c64b9e0783c9e3d6ac06c555.jpeg",
    "https://cdn.faire.com/fastly/69ef8612f018dc6aabb133638cd977a67c05757b1e4dde7585871383638ef0d0.jpeg",
    "https://cdn.faire.com/fastly/e3feaf8c468a7c0fad21ae7113f7c90f6095a329cceb3afb24a7021f40840c52.jpeg",
    "https://cdn.faire.com/fastly/c7233e6173ae6a8794fca97a6affa94fd9a33b766a4b1529f049cfc7033098e5.jpeg",
    "https://cdn.faire.com/fastly/6316cb59a30d2f290b3659b0a80aa3d8da1a96ebfbaeb6c636fbe04e92a536fa.jpeg",
    "https://cdn.faire.com/fastly/71e69f8907f5905ac4060c582ff5cf5a1678d532bf002ea103de51bdae8682f5.jpeg",
    "https://cdn.faire.com/fastly/eb09f70c59e5993dd050779dbd9fb89d5ea562148fc9fa8294b5fb5ac5e46cdd.jpeg",
    "https://cdn.faire.com/fastly/d0f840e6a83a50f7ac1cf9180e2ba837a005dfa03f9dfbb165c667092fbbe073.jpeg",
  ],
  priceDollars: 19.33,
  description:
    "Step into the soul of the desert with this Sedona, Arizona – Red Earth Reverie T-shirt. Featuring a weathered cowboy boot resting in the red rock landscape, this design captures the rugged beauty and timeless charm of the Southwest.\n\nSoft, vintage, and full of wanderlust, it’s perfect for travelers, adventurers, and those who love Sedona’s desert magic.\n\n• Comfort Colors tee for a soft, lived-in feel\n• Unisex fit, true to size\n• Ideal for desert lovers and souvenir shops\n• Designed for fans of western and travel-inspired art\n\nPrinted on Comfort Colors® blanks with soft-hand ink, it’s as cozy and calming as the otter itself. Add your location, phrase, or date to create a truly personal piece. MOQ 32 per design.\n\nProduct Features: 100% ring-spun cotton (Comfort Colors® blank) Garment-dyed for a vintage, relaxed finish Oversized unisex fit Original artwork by in-house designers Screen printed in-house with soft-hand ink MOQ 32 per design (includes custom text)\n\nSizes S-3XL Available - *Upcharge on the 2XL and 3XL\n",
  tags: [],
  msrpDollars: 38.66,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:30.519Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
